function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { accessor, assign, constant } from "d3plus-common";
import Shape from "./Shape";
/**
    @class Circle
    @extends Shape
    @desc Creates SVG circles based on an array of data.
*/

var Circle =
/*#__PURE__*/
function (_Shape) {
  _inherits(Circle, _Shape);

  /**
      @memberof Circle
      @desc Invoked when creating a new class instance, and overrides any default parameters inherited from Shape.
      @private
  */
  function Circle() {
    var _this;

    _classCallCheck(this, Circle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Circle).call(this, "circle"));

    _this._labelBounds = function (d, i, s) {
      return {
        width: s.r * 1.5,
        height: s.r * 1.5,
        x: -s.r * 0.75,
        y: -s.r * 0.75
      };
    };

    _this._labelConfig = assign(_this._labelConfig, {
      textAnchor: "middle",
      verticalAlign: "middle"
    });
    _this._name = "Circle";
    _this._r = accessor("r");
    return _this;
  }
  /**
      @memberof Circle
      @desc Provides the default positioning to the <rect> elements.
      @private
  */


  _createClass(Circle, [{
    key: "_applyPosition",
    value: function _applyPosition(elem) {
      var _this2 = this;

      elem.attr("r", function (d, i) {
        return _this2._r(d, i);
      }).attr("x", function (d, i) {
        return -_this2._r(d, i) / 2;
      }).attr("y", function (d, i) {
        return -_this2._r(d, i) / 2;
      });
    }
    /**
        @memberof Circle
        @desc Draws the circles.
        @param {Function} [*callback*]
        @chainable
    */

  }, {
    key: "render",
    value: function render(callback) {
      _get(_getPrototypeOf(Circle.prototype), "render", this).call(this, callback);

      var enter = this._enter.call(this._applyStyle.bind(this));

      var update = this._update;

      if (this._duration) {
        enter.attr("r", 0).attr("x", 0).attr("y", 0).transition(this._transition).call(this._applyPosition.bind(this));
        update = update.transition(this._transition);

        this._exit.transition(this._transition).attr("r", 0).attr("x", 0).attr("y", 0);
      } else {
        enter.call(this._applyPosition.bind(this));
      }

      update.call(this._applyStyle.bind(this)).call(this._applyPosition.bind(this));
      return this;
    }
    /**
        @memberof Circle
        @desc Given a specific data point and index, returns the aesthetic properties of the shape.
        @param {Object} *data point*
        @param {Number} *index*
        @private
    */

  }, {
    key: "_aes",
    value: function _aes(d, i) {
      return {
        r: this._r(d, i)
      };
    }
    /**
        @memberof Circle
        @desc If *value* is specified, sets the radius accessor to the specified function or number and returns the current class instance.
        @param {Function|Number} [*value*]
        @chainable
        @example
    function(d) {
    return d.r;
    }
    */

  }, {
    key: "r",
    value: function r(_) {
      return arguments.length ? (this._r = typeof _ === "function" ? _ : constant(_), this) : this._r;
    }
  }]);

  return Circle;
}(Shape);

export { Circle as default };